<template>
  <v-card>
    <v-card-title class="text-h5 align-center bb-1">
      <v-icon class="pr-2" color="secondary">mdi-bank-transfer</v-icon>
      NACHA Export Validation
    </v-card-title>

    <v-card-text class="pt-6 pb-8">
      <div class="text-center">
        <v-progress-circular
          :rotate="360"
          :size="100"
          :width="15"
          :value="progress"
          color="primary"
        >
          {{ progress }}%
        </v-progress-circular>

        <p class="mt-6 text-body-1">{{ message }}</p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'NachaValidationModal',
  props: ['onClose'],
  data() {
    return {
      progress: 0,
      message: 'Starting validation...',
    }
  },
  mounted() {
    // Listen for progress updates from the store
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === 'updateNachaValidationProgress') {
        this.progress = mutation.payload.progress
        this.message = mutation.payload.message
      }
    })
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
}
</script>

<style scoped></style>
